export default "__VITE_ASSET__51cf9b81__"